
<template>
    <div class="header">
      <div class="arrow">
      <span class="header-text">{{value}}</span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Header',
    props: {
        value: {
            type: String,
            required: true
        }
    }
  }
  </script>
  
  <style scoped>
  .header {
    width: 100%;
    height: 50px; /* Adjust the height as needed */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .arrow {
    position: relative;
    width: 100%; /* Adjust the width as needed */
    height: 30px; /* Adjust the height as needed */
    background: linear-gradient(to right, #17a2b8, #5384d1); /* Gradient color */
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 14px; /* Adjust the font size as needed */
    font-weight: bold; /* Adjust the font weight as needed */
    text-align: center;
  }
  
  .arrow::before,
  .arrow::after {
    content: '';
    position: absolute;
    top: 0;
    width: 0;
    height: 0;
    border-top: 15px solid transparent; /* Half of the height of .arrow */
    border-bottom: 15px solid transparent; /* Half of the height of .arrow */
  }
  
  .arrow::before {
    left: -15px;
    border-right: 15px solid #17a2b8; /* Matching the left gradient color */
  }
  
  .arrow::after {
    right: -15px;
   border-left: 15px solid #5384d1; /* Matching the right gradient color */
  }
  </style>